import React from 'react';
import { Register } from '../factory';
import { Tag } from 'antd-mobile';

@Register({ name: 'dy-radio' })
class DyRadio extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {};
    }
    localValue: any = null;
    handleChange = value => {
        this.localValue = value;
        this.props.onChange && this.props.onChange(value);
    };

    render() {
        let { className, name, options, value } = this.props;
        let { localValue } = this;
        return (
            <div className="commit-form-item-radio">
                {options.map((option, index) => (
                    <Tag key={index} selected={localValue && localValue == option.seq} onChange={() => this.handleChange(option.seq)}>
                        {option.content}
                    </Tag>
                ))}
            </div>
        );
    }
}

export default DyRadio;
